import { Trans, useTranslation } from 'react-i18next'

import { refundMethods, returnStatuses } from '@reveni-io/reveni-ui'

import { getTextForWhenIssueRefund } from '@/helpers'

import InstantReveniHeader from '../InstantReveniHeader/InstantReveniHeader'
import { Container } from './styles'

const OriginalPaymentMethodMessage = ({
  amount,
  instant,
  currency = 'EUR',
  issueRefundAtStatus,
  isCancellationsPortal,
}) => {
  const { t, i18n } = useTranslation()
  const textForWhenIssueRefund = getTextForWhenIssueRefund(t, issueRefundAtStatus)

  if (isCancellationsPortal) {
    return (
      <Container>
        <p>{t('Reembolso tradicional')}</p>
        <p>
          <Trans
            i18nKey="opmCancellationsPortalMessage"
            values={{ amount: new Intl.NumberFormat(i18n.language, { style: 'currency', currency }).format(amount) }}
          />
        </p>
      </Container>
    )
  }

  return (
    <Container>
      {instant ? (
        <>
          <InstantReveniHeader type={refundMethods.originalPaymentMethod} />
          <p>
            <Trans
              i18nKey="opmInstantMessage"
              values={{
                amount: new Intl.NumberFormat(i18n.language, { style: 'currency', currency }).format(amount),
              }}
            />
          </p>
          <p>
            <Trans i18nKey="opmInstantTimeMessage" />
          </p>
        </>
      ) : (
        <>
          <p>{t('Reembolso tradicional')}</p>
          <p>
            <Trans
              i18nKey="opmNormalMessage"
              values={{
                amount: new Intl.NumberFormat(i18n.language, { style: 'currency', currency }).format(amount),
                textForWhenIssueRefund,
              }}
            />
          </p>
          <p>{issueRefundAtStatus === returnStatuses.accepted && <Trans i18nKey="opmNormalTimeMessage" />}</p>
        </>
      )}
    </Container>
  )
}

export default OriginalPaymentMethodMessage
